import React, { useEffect } from 'react';

const Team: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 via-white to-warm-100 py-20">
      <div className="container mx-auto px-6 max-w-4xl">
        <h1 className="text-5xl font-elegant font-bold text-primary-800 mb-8 text-center">Our Team</h1>
        <p className="text-xl text-secondary-700 mb-6 text-center">
          Meet the passionate individuals behind SoundX724. Our team is a blend of musicians, educators, technologists, and 
            cultural enthusiasts dedicated to bringing the best of Indian classical music to the world.
        </p>
        <div className="grid md:grid-cols-2 gap-8">
          <div className="bg-white rounded-2xl shadow-lg p-8 flex flex-col items-center">
            <img src="/img/team-img/rigved.png" alt="Rigved Deshpande" className="w-32 h-32 rounded-full mb-4 object-cover" />
            <h2 className="text-xl font-bold text-primary-700 mb-2">Rigved Deshpande</h2>
            <p className="text-secondary-700 text-lg mb-2">Volunteer, Musician & Founder</p>
            <p className="text-secondary-600 text-center">Visionary behind SoundX724, passionate about blending tradition and technology. An ace tabla player and singer have performed in various prestigious events and concerts in India and abroad.</p>
          </div>
          <div className="bg-white rounded-2xl shadow-lg p-8 flex flex-col items-center">
            <img src="/img/team-img/niranjan.png" alt="Niranjan Rode" className="w-32 h-32 rounded-full mb-4 object-cover" />
            <h2 className="text-xl font-bold text-primary-700 mb-2">Niranjan Rode</h2>
            <p className="text-secondary-700 text-lg mb-2">Volunteer Product Lead</p>
            <p className="text-secondary-600 text-center">Passionate about bridging the gap between business strategy and product development, defining the technical requirements for a product and guides our core team.</p>
          </div>
          <div className="bg-white rounded-2xl shadow-lg p-8 flex flex-col items-center">
            <img src="/img/team-img/himanshu.png" alt="Himanshu Kharat" className="w-32 h-32 rounded-full mb-4 object-cover" />
            <h2 className="text-xl font-bold text-primary-700 mb-2">Himanshu Kharat</h2>
            <p className="text-secondary-700 text-lg mb-2">Volunteer Operations</p>
            <p className="text-secondary-600 text-center">To Himanshu, music is an emotion, a story, and the universal language that connects us all. It's his deepest source of joy and inspiration—more than entertainment, songs are a conduit for expressing feelings and reliving memories.</p>
          </div>
          <div className="bg-white rounded-2xl shadow-lg p-8 flex flex-col items-center">
            <img src="/img/team-img/sanat.png" alt="Sanat Kakde" className="w-32 h-32 rounded-full mb-4 object-cover" />
            <h2 className="text-xl font-bold text-primary-700 mb-2">Sanat Kakde</h2>
            <p className="text-secondary-700 text-lg mb-2">Volunteer Marketing</p>
            <p className="text-secondary-600 text-center">A music lover with a knack for marketing, Sanat is always excited to support the music group—helping amplify its message, grow its audience, and spread harmony beyond the stage.</p>
          </div>
          <div className="bg-white rounded-2xl shadow-lg p-8 flex flex-col items-center">
            <img src="/img/team-img/guru.png" alt="Gurunath Chatuphale" className="w-32 h-32 rounded-full mb-4 object-cover" />
            <h2 className="text-xl font-bold text-primary-700 mb-2">Gurunath Chatuphale</h2>
            <p className="text-secondary-700 text-lg mb-2">Volunteer Media & Musician</p>
            <p className="text-secondary-600 text-center">Guru bridges artistry and strategy. A musician and storyteller at heart, he curates performances that connect cultures and emotions. His vision drives the collective's mission to bring Indian classical music to new audiences across Canada.</p>
          </div>
          <div className="bg-white rounded-2xl shadow-lg p-8 flex flex-col items-center">
            <img src="/img/team-img/harshal.png" alt="Harshal Chandorkar" className="w-32 h-32 rounded-full mb-4 object-cover" />
            <h2 className="text-xl font-bold text-primary-700 mb-2">Harshal Chandorkar</h2>
            <p className="text-secondary-700 text-lg mb-2">Volunteer & Musician</p>
            <p className="text-secondary-600 text-center"></p>
          </div>         
        </div>
        <div className="mt-12 text-center text-secondary-700">
          <p>Want to join our team? Email us at <a href="mailto:soundx724@gmail.com" className="text-primary-600 underline">soundx724@gmail.com</a></p>
        </div>
      </div>
    </div>
  );
};

export default Team;
